import { useSite } from "../context/SiteContext";

const Row = ({ hidden, regions }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {regions.map((r, i) => (
      <span key={i} className="flex items-center font-display text-3xl text-sand sm:text-5xl">
        <span className="px-8 sm:px-12">{r}</span>
        <span className="h-2.5 w-2.5 rounded-full bg-clay-soft" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { regions } = useSite();
  return (
  <section data-testid="regions-marquee" className="mt-20 overflow-hidden bg-ink py-10 sm:mt-28 sm:py-14">
    <p className="mx-auto mb-6 max-w-7xl px-5 text-xs font-semibold uppercase tracking-[0.22em] text-sand/70 sm:px-8">
      Our portfolio spans {regions.length} Bali regions
    </p>
    <div className="marquee-track flex w-max">
      <Row regions={regions} />
      <Row hidden regions={regions} />
    </div>
  </section>
  );
};
